import { createContext } from "react"
import { InViewTreeType } from "@/components/Catalog/Categories/types"

export const CategoriesContext = createContext<null | {
  inViewTree: InViewTreeType
}>(null)
